import { inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';

import { AuthService } from './auth.service';
import { PermissionService } from '../services/user/permission.service';

export const isLogged = (authService = inject(AuthService)) => authService.checkLogin();
export const checkPermissions = (route: ActivatedRouteSnapshot, permissionService = inject(PermissionService)) => permissionService.checkPermissions(route.data);